module.exports = __webpack_public_path__ + "static/img/r-6.2d77e74.png";


//////////////////
// WEBPACK FOOTER
// ./src/products/r-6.png
// module id = w5Tv
// module chunks = 0